'use es6';

import { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withUniqueMenuId() {
  return Component => {
    const WithUniqueMenuId = /*#__PURE__*/forwardRef((props, ref) => {
      const generatedMenuId = useMemo(() => uniqueId('MenuId'), []);
      const menuId = props.menuId || generatedMenuId;
      return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
        ref: ref,
        menuId: menuId
      }));
    });
    WithUniqueMenuId.displayName = `WithUniqueMenuId(${Component.displayName || Component.name || 'Component'})`;
    WithUniqueMenuId.propTypes = {
      menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    };
    return WithUniqueMenuId;
  };
}